<template>
  <div>
    <RadarChart
      v-if="loaded"
      class="chart"
      :style="styleChart"
      :chart-data="datacollection"
      :options="options"
    ></RadarChart>
  </div>
</template>

<script>
import APIService from '../../APIService'
export default {
  components: {
    RadarChart: () => import('./RadarChart.js')
  },
  props: {
    queryId: {
      type: String,
      default: null
    },
    schema: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    styleChart: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      allDataSet: {},
      loaded: false,
      datacollection: null,
      display: true,
      backgroundColor: [
        '#A989C5',
        '#5CC2F9',
        '#509EE3',
        '#88BF4D',
        '#98D9D9',
        '#ff9999',
        '#ffaa80',
        '#00e600',
        '#F9D45C',
        '#7070db'
      ],
      labels: [],
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        responsive: 'true',
        title: {
          display: true,
          text: this.title,
          fontSize: 15
        },
        scale: {
          angleLines: {
            display: false
          },
          ticks: {
            suggestedMin: 1,
            suggestedMax: 10
          }
        }
      },
      dataVal: [],
      items: null
    }
  },

  created() {
    if (this.queryId != null) {
      APIService.getQueryData(this.queryId)
        .then((res) => {
          this.items = res.data
          this.items.forEach((element) => {
            this.dataVal.push(element.count)
            this.labels.push(element._id)
          })

          this.allDataSet = {
            label: this.label,
            borderColor: '#509EE3',
            backgroundColor: '#e6f9ff',
            data: this.dataVal
          }
          this.fillData()
          this.loaded = true
        })
        .catch((ex) => {
          console.log(ex.response)
        })
    }
  },

  mounted() {
    this.loaded = false
  },

  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labels,
        datasets: [this.allDataSet]
      }
    }
  }
}
</script>
<style scoped>
.chart {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 8px;
  padding: 10px;
}
</style>
